import { FilePickerAdapter, FilePreviewModel } from 'ngx-awesome-uploader';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { DropBoxService } from '../../form-fields/drop-box-upload/drop-box.service';

export class DemoFilePickerAdapter extends FilePickerAdapter {
  constructor(private _googleDriveService: DropBoxService) {
    super();
  }

  public uploadFile(fileItem: FilePreviewModel) {
    return this._googleDriveService.upload([fileItem.file as File]).pipe(map(([file]) => file.id));
  }
  public removeFile(fileItem): Observable<any> {
    return of(fileItem);
  }
}
